import React from 'react';
import _ from 'lodash';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { Slider } from '../../../../../../common/components/slider';
import ImgCompnent from './imgComponent';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container';


const settings = {
  arrows: true,
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 6,
  slidesToScroll: 6
};

export const TicketBasicInfoComponent = ({
  departments,
  employees,
  ticketType,
  ticketPriority,
  onFormChange,
  selectedTicket,
  id,
  accountTypesList,
  accountsList
}: any) => {
  return (
    <>
      <AccordionContainer
        child={
          <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4">
            <InputContainer
              isDisabled={Number(id) !== 0}
              label="Account Type"
              labelField="Name"
              list={accountTypesList}
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'AssociatedAccountTypeId',
                });
              }}
              optionName='Choose Account Type'
              type="select"
              value={selectedTicket?.AssociatedAccountTypeId}
              valueField="Id"
            />
            <InputContainer
              isDisabled={Number(id) !== 0}
              label="Account Name"
              labelField="Name"
              list={accountsList}
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'AssociatedAccountId'
                });
              }}
              optionName='Choose Account Name'
              type="select"
              value={selectedTicket?.AssociatedAccountId}
              valueField="Id"
            />
            <InputContainer
              isDisabled={Number(id) !== 0}
              label="Requestor Name"
              name="RequestorName"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'RequestorName'
                });
              }}
              type="text"
              value={selectedTicket?.RequestorName}
            />


            <InputContainer
              isDisabled={Number(id) !== 0}
              label="Requestor Email"
              name="RequestorEmailId"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'RequestorEmailId'
                });
              }}
              type="email"
              value={selectedTicket?.RequestorEmailId}
            />


            <InputContainer
              isDisabled={Number(id) !== 0}
              label="Requestor PhoneNumber"
              name="RequestorPhoneNo"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'RequestorPhoneNo'
                });
              }}
              type="number"
              value={selectedTicket?.RequestorPhoneNo}
            />
            <InputContainer
              isDisabled={Number(id) !== 0}
              label="Department"
              labelField="Name"
              list={departments}
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'DepartmentId'
                }

                );
              }}
              optionName='Choose Department'
              type="select"
              value={selectedTicket?.DepartmentId}
              valueField="Id"
            />
            <InputContainer
              label="Employee"
              labelField="FirstName"
              list={employees}
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'EmployeeId'
                }

                );
              }}
              optionName='Choose Employee'
              type="select"
              value={selectedTicket?.EmployeeId}
              valueField="Id"
            />

            <InputContainer
              isDisabled={Number(id) !== 0}
              label="Ticket Type"
              labelField="Text"
              list={ticketType}
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'TicketTypeId'
                });
              }}
              optionName='Choose TicketType'
              type="select"
              value={selectedTicket?.TicketTypeId}
              valueField="Value"
            />


            <InputContainer
              label="Ticket Priority"
              labelField="Text"
              list={ticketPriority}
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'TicketPriorityId'
                });
              }}
              optionName='Choose TicketPriority'
              type="select"
              value={selectedTicket?.TicketPriorityId}
              valueField="Value"
            />


            <InputContainer
              isDateTimePicker
              isDisabled={Number(id) !== 0}
              label="Expected Response Before"
              name="DueDateOnUtc"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'DueDateOnUtc'
                });
              }}
              type="date"
              value={selectedTicket?.DueDateOnUtc}
            />


            <InputContainer
              isDateTimePicker
              isDisabled={Number(id) !== 0}
              label="Expected Resolution Before"
              name="DueDateOnUtc"
              onValueChange={(event: any) => {
                onFormChange({
                  value: event.target.value,
                  field: 'DueDateOnUtc'
                });
              }}
              type="date"
              value={selectedTicket?.DueDateOnUtc}
            />

            <div className="col-span-full">
              <InputContainer
                isDisabled={Number(id) !== 0}
                label="Subject"
                name="Subject"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'Subject'
                  });
                }}

                type="text"
                value={selectedTicket?.Subject}
              />
            </div>
            <div className="col-span-full">
              <InputContainer
                isDisabled={Number(id) !== 0}
                label="Description"
                name="Description"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'Description'
                  });
                }}

                type="text"
                value={selectedTicket?.Description}
              />
            </div>
            <div className="col-span-full">
              {selectedTicket?.message?.issue?.description?.additional_desc?.url ? (
                <a
                  href={selectedTicket?.message?.issue?.description?.additional_desc?.url}
                  rel="noreferrer"
                  target="_blank"
                >
                  Additional Information
                </a>
              ) : null}
            </div>
            {selectedTicket?.MediaMappings?.MediaFiles && selectedTicket?.MediaMappings?.MediaFiles?.length > 0 ? (
              <div className="col-span-full">
                <InputLabelContainer
                  label="Images"
                />
                <Slider {...settings} data={_.map(selectedTicket?.MediaMappings?.MediaFiles, (item: any) => {
                  return {
                    url: `${item?.FileMappingURL}`
                  }
                })}>
                </Slider>
              </div>
            ) : <></>}
          </div>
        }
        expandedPanel="basicInfo"
        headerTitle="Basic Info"
      />
    </>
  )
};
